import {Box, Flex, List, ListItem, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Checkbox} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IProduct} from 'types';
import {CrossSellingSections} from 'utils/provider';

interface Props {
  onChange: (product: IProduct) => void;
  selectedOptions: number[];
  t: (term: TranslationKeys) => string;
  crossSelingProducts: CrossSellingSections[];
}

export const CrossSellingSets: FC<Props> = ({t, crossSelingProducts, onChange, selectedOptions}) => {
  if (!crossSelingProducts) return null;

  return (
    <List>
      {crossSelingProducts.map((crossProduct) => {
        return (
          <ListItem key={crossProduct.name} mb={['15px', '36px']}>
            <Box mb={['15px', '30px']}>
              <Text fontSize={['16px', '18px']} fontWeight={600} mb="15px">
                {crossProduct.name}
              </Text>
            </Box>
            <List>
              {crossProduct.products.map((option_set) => {
                const {id, name, price} = option_set;

                const isCheckOption = selectedOptions.includes(id);
                const checkboxType = 'square';
                const isDisabled = false; //!isCheckOption && isFullySelected;

                return (
                  <Flex
                    key={id}
                    justifyContent="space-between"
                    alignItems="center"
                    borderTop="1px"
                    borderColor={colors.borderGray}
                  >
                    <ListItem display="flex" justifyContent="space-between" h="56px" alignItems="center">
                      <Checkbox
                        cursor={isDisabled ? 'no-drop' : 'pointer'}
                        variant={checkboxType}
                        isDisabled={isDisabled}
                        onChange={() => onChange(option_set)}
                        isChecked={isCheckOption}
                        _focus={{border: 'none'}}
                      >
                        <Text as="span" fontSize={['14px', '18px']} fontWeight={500}>
                          {name} +
                          <Text as="span" fontWeight={500} ml="5px">
                            {price} {t('CURRENCY')}
                          </Text>
                        </Text>
                      </Checkbox>
                    </ListItem>
                  </Flex>
                );
              })}
            </List>
          </ListItem>
        );
      })}
    </List>
  );
};
